export const STUDIO_AND_APARTMENT_FEATURES = [
  3000, 3016, 3018, 3011, 3012, 3013, 3019, 3014, 3009, 3008, 3002, 3100, 3028,
  3007, 5003, 3015
];

export const ROOM_SHARED_AND_RESIDENCE_FEATURES = [
  4003, 4005, 4000, 4004, 4102, 4103, 4006, 5003, 4001, 4002, 4101, 3019
];
